
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/results/reveal",
      function () {
        return require("private-next-pages/results/reveal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/results/reveal"])
      });
    }
  